import React from 'react';
import { useParams } from 'react-router-dom';

const BlogPost = () => {
  const { id } = useParams();

  return (
    <div className="blog-post-container">
      <h1>Blog Post #{id}</h1>
      <div className="post-meta">
        <span className="post-date">Date: March 30, 2023</span>
        <span className="post-author">Author: Admin</span>
      </div>
      <div className="post-content">
        <p>This is a placeholder for the blog post content.</p>
      </div>
    </div>
  );
};

export default BlogPost; 